import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Select from 'react-select';
import Calendar from 'react-calendar';

import { Modal } from 'semantic-ui-react';
import { DEFAULT_COMPLEX_TYPE } from '../../../constants/appConstants';
import { toastError } from '../../../utils/toastMessage';
import formatDate from '../../../utils/formatDate';
import API from '../../../utils/API';

const COMPLEX_PERIODS = [
  {
    value: 2,
    label: '2 дня',
  },
  {
    value: 3,
    label: '3 дня',
  },
  {
    value: 7,
    label: '7 дней',
  },
  {
    value: 14,
    label: '14 дней',
  },
  {
    value: 16,
    label: '16 дней',
  },
  {
    value: 30,
    label: '30 дней',
  },
  {
    value: 37,
    label: '37 дней',
  },
];

const DEFAULT_PERIOD = 7;

const CreateComplexModal = ({ isShow, onClose, userId, getComplexes }) => {
  const [isBindToDate, setBindToDate] = useState(false);
  const [startComplexDate, setStartComplexDate] = useState(undefined);
  const [selectedPeriodValue, setSelectedPeriodValue] = useState(DEFAULT_PERIOD);
  const [isLoadingSaveComplex, setIsLoadingSaveComplex] = useState(false);
  const [isComplexType, setIsComplexType] = useState(0);
  const history = useHistory();

  const changeBindToDate = () => {
    if (isBindToDate) {
      setStartComplexDate(undefined);
    } else {
      setStartComplexDate(new Date());
    }
    setBindToDate(!isBindToDate);
  };

  const submitSaveComplex = () => {
    setIsLoadingSaveComplex(true);

    const reqBody = {
      duration: selectedPeriodValue,
      user_id: userId,
      is_individual: isComplexType,
    };

    if (isBindToDate) {
      reqBody.started_at = formatDate(startComplexDate);
    }

    API.post('/complexes', reqBody)
      .then(() => {
        getComplexes(userId); // refresh user complexes
        setBindToDate(false);
        setStartComplexDate(undefined);
        setSelectedPeriodValue(DEFAULT_PERIOD);
        setIsLoadingSaveComplex(false);
        onClose();
      })
      .then(() => {
        history.push('/');
      })
      .catch(() => {
        setIsLoadingSaveComplex(false);
        toastError('Ошибка создания комплекса');
      });
  };

  if (!isShow) return null;

  return (
    <Modal open={isShow} closeIcon size="tiny" onClose={onClose}>
      <WrapModal>
        <WrapHeadModal>
          <TitleModal>Создание комплекс курса</TitleModal>
        </WrapHeadModal>
        <WrapBodyModal>
          <SubtitleModal>Период:</SubtitleModal>
          <WrapPeriods>
            {COMPLEX_PERIODS.map((period) => {
              return (
                <React.Fragment key={`${period.value}days`}>
                  <RadioButton
                    id={`${period.value}days`}
                    value={period.value}
                    name="complexPeriod"
                    type="radio"
                    checked={period.value === selectedPeriodValue}
                    onChange={(e) => setSelectedPeriodValue(+e.target.value)}
                  />
                  <Label htmlFor={`${period.value}days`}>{period.label}</Label>
                </React.Fragment>
              );
            })}
          </WrapPeriods>
          <H1>Укажите тип курса</H1>
          <Select
            options={DEFAULT_COMPLEX_TYPE}
            defaultValue={isComplexType}
            clearable={false}
            value={isComplexType}
            onChange={(e) => setIsComplexType(e.value)}
            placeholder="Выберите тип курса..."
          />
          <SubtitleModal>Начальная дата:</SubtitleModal>
          <BindToDateCheckbox
            id="bindToDateCheckbox"
            type="checkbox"
            checked={!isBindToDate}
            onChange={changeBindToDate}
          />
          <Label htmlFor="bindToDateCheckbox">Не привязывать к дате</Label>
          <Calendar
            minDate={new Date()}
            showNavigation={isBindToDate}
            value={startComplexDate}
            tileDisabled={() => !isBindToDate}
            onChange={setStartComplexDate}
          />
          <CreateComplexButton onClick={submitSaveComplex} disabled={isLoadingSaveComplex}>
            Создать
          </CreateComplexButton>
        </WrapBodyModal>
      </WrapModal>
    </Modal>
  );
};

export default CreateComplexModal;

const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
`;

const WrapModal = styled.div`
  min-width: 300px;
  width: 100%;
  min-height: 350px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: white;
`;

const WrapHeadModal = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TitleModal = styled.div`
  font-size: 30px;
  margin: 7px 7px;
`;

const WrapBodyModal = styled.div`
  margin: 7px;
`;

const RadioButton = styled.input`
  margin-right: 5px;
`;

const Label = styled.label`
  margin-right: 10px;
`;

const SubtitleModal = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0px;
`;

const WrapPeriods = styled.div`
  display: flex;
`;

const BindToDateCheckbox = styled.input`
  margin-bottom: 10px;
`;

const CreateComplexButton = styled.button`
  display: block;
  width: 100%;
  height: 40px;
  font-size: 20px;
  margin-top: 20px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background: ${(props) => (props.disabled ? '#999999' : '#3a3a3a')};
  &:hover {
    color: #3a3a3a;
    background: #4f93c3;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/Complex/CreateComplexModal.jsx